import React from "react";
import { Link } from "react-router-dom";
import { formatDateLastMessage } from "../../utils/date";
import {
  formatSystemMessagePreview,
  selectPrivatePeerMembers,
} from "./systemMessageText";

function ChatListItem({
  chat,
  members,
  myEmail,
  myUserId,
  activeChatId,
  unread,
  isPeerOnline = false,
}) {
  const get_last_message_text = () => {
    const last_message = chat?.last_message;
    if (last_message == null) return;
    switch (last_message.type) {
      case "system":
        return formatSystemMessagePreview(last_message.system_data);
      case "user":
        if (last_message.is_entity_share) {
          return "Надіслано картку";
        }
        return last_message.text;
      default:
        return "";
    }
  };

  const peerMembers = chat?.is_group
    ? []
    : selectPrivatePeerMembers(members, myEmail, myUserId);

  const showOnlineDot = Boolean(!chat?.is_group && isPeerOnline);

  return (
    <Link
      to={`/chats/${chat.id}`}
      className={`user-message ${String(chat.id) === String(activeChatId) && "active"}`}
      key={chat.id}
    >
      <div className="people-img">
        <span className="chat-list-user-icon">
          {chat?.is_group ? (
            <img src={chat.image || "/images/no-profile-picture.png"} alt="" className="content-user-photo" />
          ) : (
            peerMembers.map((member) => (
              <img
                key={member.user.id}
                src={member.user.user_image ? member.user.user_image : "/images/no-profile-picture.png"}
                alt=""
                className="content-user-photo"
              />
            ))
          )}
          {showOnlineDot ? (
            <span
              className="chat-list-presence-dot"
              data-presence-kind="online"
              data-testid={`chat-list-presence-dot-${chat.id}`}
              aria-hidden="true"
            />
          ) : null}
        </span>
      </div>
      <div className="people-messages">
        <div className="user-name">
          {chat?.is_group
            ? (chat.name || members.map((m) => m.user.fullname).join(", "))
            : peerMembers.map((member) => member.user.fullname).join(", ")}
        </div>
        <div className="text">
          {get_last_message_text()}
        </div>
      </div>
      <div className="time">
        {chat.last_message ? formatDateLastMessage(chat.last_message.created_at) : "Нове"}
        {unread > 0 && (
          <span className="chat-unread-badge" aria-label={`${unread} непрочитаних`}>
            {unread}
          </span>
        )}
      </div>
    </Link>
  );
}

export default React.memo(ChatListItem);
